export default "__VITE_ASSET__FYLcYppc__"